export default __webpack_public_path__ + "static/media/P940_Home.5948a5e5.png";